import ScanSearch from '../../components/ScanSearch'
import Icon from '../../components/Icon'
import * as productosApi from '../../api/productos'

const nf = (n) => Math.round(Number(n) || 0).toLocaleString('es-PY')

// ③ Productos — barra de carga POS (búsqueda + dropdown) + tabla con stepper e inputs inline.
export default function DetalleProductos({ vm }) {
  const lineas = vm.productos.filter((d) => d.producto)

  const renderResult = (it) => (
    <>
      <div>
        <div className="r-name">{it.nombre}</div>
        <div className="r-sub"><span className="mono">{it.codigo}</span>{it.codigoBarrasPrincipal?.codigoBarras ? <> · {it.codigoBarrasPrincipal.codigoBarras}</> : ''}</div>
      </div>
      <span className="r-price">{nf(it.precioVenta || 0)}</span>
    </>
  )

  return (
    <>
      <ScanSearch
        placeholder="Escaneá un código de barras o buscá por nombre / código…"
        fetcher={(s) => productosApi.buscarProductos(s)}
        onSelect={(p) => vm.addProductoConDatos(p)}
        renderResult={renderResult}
        minChars={2}
      />

      {lineas.length === 0 ? (
        <div style={{ padding: '40px 24px', textAlign: 'center', color: 'var(--text-muted)' }}>
          <div style={{ fontSize: 13, marginBottom: 4 }}>Aún no agregaste productos</div>
          <div style={{ fontSize: 12, color: 'var(--text-dim)' }}>Escaneá un código o buscá arriba para empezar.</div>
        </div>
      ) : (
        <table className="products-table">
          <thead>
            <tr>
              <th style={{ width: 32 }}>#</th>
              <th>Producto</th>
              <th>Unidad</th>
              <th className="num" style={{ width: 110 }}>Cant.</th>
              <th className="num" style={{ width: 120 }}>Precio</th>
              <th className="num" style={{ width: 90 }}>Desc. %</th>
              <th className="num">IVA</th>
              <th className="num">Subtotal</th>
              <th style={{ width: 36 }} />
            </tr>
          </thead>
          <tbody>
            {vm.productos.map((d, i) => d.producto && (
              <tr key={i}>
                <td style={{ color: 'var(--text-dim)' }}>{lineas.indexOf(d) + 1}</td>
                <td>
                  <div className="item-name">{d.producto.nombre}</div>
                  <div className="item-sku mono">{d.producto.codigo}{d.producto.codigoBarrasPrincipal?.codigoBarras ? <> · <span style={{ color: 'var(--text-dim)' }}>{d.producto.codigoBarrasPrincipal.codigoBarras}</span></> : ''}</div>
                </td>
                <td>{d.unidadMedida?.abreviatura || '—'}</td>
                <td className="num">
                  <span className="qty-cell">
                    <button type="button" title="Restar" onClick={() => vm.updateProducto(i, { cantidad: Math.max(0, (Number(d.cantidad) || 0) - 1) })}>−</button>
                    <input value={d.cantidad} onChange={(e) => vm.updateProducto(i, { cantidad: e.target.value })} />
                    <button type="button" title="Sumar" onClick={() => vm.updateProducto(i, { cantidad: (Number(d.cantidad) || 0) + 1 })}>+</button>
                  </span>
                </td>
                <td className="num"><input className="inline-input" value={d.precioVenta} onChange={(e) => vm.updateProducto(i, { precioVenta: e.target.value })} /></td>
                <td className="num"><input className="inline-input sm" value={d.descuento} onChange={(e) => vm.updateProducto(i, { descuento: e.target.value })} /></td>
                <td className="num" style={{ color: 'var(--text-muted)' }}>{d.montosImponibles?.[0]?.tipoImpuesto?.porcentaje ?? 0}%</td>
                <td className="num mono" style={{ fontWeight: 600 }}>{nf(d.totalItem)}</td>
                <td><span className="row-action" title="Quitar" onClick={() => vm.removeProducto(i)}><Icon name="trash" size={13} /></span></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  )
}
